exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pagination{margin-top:0;margin-bottom:0;width:100%}.pagination-showing{font-size:11px;padding:0 33px;color:#626262}.pagination-links,.pagination-per-page{text-align:right;float:left;padding:0 33px}.pagination-links .small{color:#626262;opacity:.5}.pagination ul li{display:inline;padding-left:10px;padding-right:10px}.pagination ul li a{color:#626262;opacity:.5;font-size:11px}.pagination ul li a.disabled{opacity:.2;cursor:default}.pagination ul li a.active{font-weight:700;color:#626262;opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7e7517c6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pagination.vue
// module id = 1265
// module chunks = 1